import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const studentsStatuses = async (assignmentId) =>
  await requestSdk(() =>
    get(`${BASE_URL}/v1/trackers/assignments/${assignmentId}/students-status/`)
  );
